/**
 * Represents the GraphQl schema retrieved via introspection of the GraphQl endpoint.
 */
export type GraphQlSchema = {
  objectTypes: Map<string, GraphQlType>;
  inputTypes: Map<string, GraphQlType>;
  scalars: Map<string, GraphQlType>;
  enums: Map<string ,GraphQlEnum>;
};

/**
 * Represents single type in the {@link GraphQlSchema}.
 */
export type GraphQlType = {
  name: string;
  kind: TypeKind;
  fields: Array<GraphQlField>;
  fieldsMap: Map<string, GraphQlField>;
  // Reference to the GraphQL schema in which this type is defined
  schemaRef: GraphQlSchema
};

/**
 * Contains the possible `kind` values in the {@link GraphQlType}.
 */
export enum TypeKind {
  SCALAR = 'SCALAR',
  OBJECT = 'OBJECT',
  INTERFACE = 'INTERFACE',
  UNION = 'UNION',
  ENUM = 'ENUM',
  INPUT_OBJECT = 'INPUT_OBJECT',
  LIST = 'LIST',
  NON_NULL = 'NON_NULL'
}

/**
 * Represents single filed in the {@link GraphQlType}.
 */
export type GraphQlField = {
  name: string;
  kind: FieldKind;
  range?: string;
  isMulti: boolean;
  arguments: Array<string>;
};

/**
 * Contains the possible `kind` values for the {@link GraphQlField}.
 */
export enum FieldKind {
  SCALAR = 'SCALAR',
  INTERFACE = 'INTERFACE',
  OBJECT = 'OBJECT',
  ENUM = 'ENUM',
  UNION = 'UNION'
}

/**
 * Represents GraphQl `Enum` type.
 */
export type GraphQlEnum = {
  name: string;
  values: Array<string>;
}
